// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradeScopeOfWorkQueryVariables = Types.Exact<{
  filter: Types.ChangeEventLineItemFilter;
}>;


export type TradeScopeOfWorkQuery = { __typename?: 'Query', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, quantity?: number | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, totalCostInCents: number, totalPriceInCents: number, displayName: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, manufacturerUrl?: string | null | undefined } } | null | undefined } | null | undefined }> };

export type TradeScopeOfWorkChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, quantity?: number | null | undefined, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, totalCostInCents: number, totalPriceInCents: number, displayName: string, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, selectedOption?: { __typename?: 'HomeownerSelectionOption', id: string, product: { __typename?: 'Product', id: string, name: string, description?: string | null | undefined, manufacturerUrl?: string | null | undefined } } | null | undefined } | null | undefined };

export const TradeScopeOfWorkChangeEventLineItemFragmentDoc = gql`
    fragment TradeScopeOfWorkChangeEventLineItem on ChangeEventLineItem {
  id
  quantity
  unitOfMeasure {
    id
    name
  }
  specifications
  tradePartnerNote
  totalCostInCents
  totalPriceInCents
  displayName
  totalCostInCents
  homeownerSelection {
    id
    selectedOption {
      id
      product {
        id
        name
        description
        manufacturerUrl
      }
    }
  }
}
    `;
export const TradeScopeOfWorkDocument = gql`
    query TradeScopeOfWork($filter: ChangeEventLineItemFilter!) {
  changeEventLineItems(filter: $filter) {
    ...TradeScopeOfWorkChangeEventLineItem
  }
}
    ${TradeScopeOfWorkChangeEventLineItemFragmentDoc}`;

/**
 * __useTradeScopeOfWorkQuery__
 *
 * To run a query within a React component, call `useTradeScopeOfWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradeScopeOfWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradeScopeOfWorkQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTradeScopeOfWorkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables> & ({ variables: TradeScopeOfWorkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>(TradeScopeOfWorkDocument, options);
      }
export function useTradeScopeOfWorkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>(TradeScopeOfWorkDocument, options);
        }
export function useTradeScopeOfWorkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>(TradeScopeOfWorkDocument, options);
        }
export type TradeScopeOfWorkQueryHookResult = ReturnType<typeof useTradeScopeOfWorkQuery>;
export type TradeScopeOfWorkLazyQueryHookResult = ReturnType<typeof useTradeScopeOfWorkLazyQuery>;
export type TradeScopeOfWorkSuspenseQueryHookResult = ReturnType<typeof useTradeScopeOfWorkSuspenseQuery>;
export type TradeScopeOfWorkQueryResult = Apollo.QueryResult<TradeScopeOfWorkQuery, TradeScopeOfWorkQueryVariables>;